









































































/* eslint-disable no-unused-vars */
import BaseComponent from '@/components/BaseComponent';
import { Component, Prop, Watch } from 'vue-property-decorator';
import LogoutConfirm from '@/components/LogoutConfirm.vue';
import { AxiosResponse } from 'axios';
/* eslint-enable no-unused-vars */

@Component({
    components: { LogoutConfirm },
})
export default class AppHeader extends BaseComponent {
    private drawer = false;
    private items = [
        { icon: 'mdi-battery-charging-wireless-alert', text: 'モニタリング', link: '/machine_list', authority: 0 },
        { icon: 'mdi-google-maps', text: '地図で表示', link: '/pmap', authority: 0 },
        { icon: 'mdi-factory', text: '会社一覧', link: '/corp_list', authority: 3 },
        { icon: 'mdi-account-details', text: 'ユーザ一覧', link: '/user_list', authority: 0 },
        { icon: 'mdi-map-marker-multiple', text: 'グループ一覧', link: '/group_list', authority: 2 },
        { icon: 'mdi-message-text-outline', text: 'イベント', link: '/event_list', authority: 0 },
        { icon: 'mdi-chart-line', text: 'バッテリ状態', link: '/battery_chart', authority: 0 },
    ];
    private searchAddress: string = ''; // 住所検索用
    private groupList: any = []; // グループ一覧
    private selectGroup: number = 0; // 選択グループ
    private logoutConfirmFlg = false;

    @Prop({ default: false }) private enableSearch!: boolean; // 検索有効フラグ

    async created() {
        if (this.enableSearch) {
            await this.getGroupList();
            if (this.groupList.length > 0) {
                this.selectGroup = this.groupList[0]['group_id'];
            }
            this.searchGroup(this.selectGroup);
        }
    }

    // 住所検索(GoogleMap.vueのイベントを呼ぶ為にpmap.vueのイベントを呼び出し)
    private moveAddress(searchAddress: string) {
        this.$emit('moveAddress', searchAddress);
        // this.$emit('moveDisplayPosition', searchAddress);
    }

    // グループ一覧の取得
    private async getGroupList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = {
                sort: true,
            };

            const resp: AxiosResponse<any> = await this.$http.post('group_list.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.groupList = resp.data.items;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // グループ検索
    private searchGroup(selectGroup: number) {
        this.$emit('searchGroup', selectGroup);
    }
    // ログアウト
    private closeLogoutDialog(value: boolean) {
        this.logoutConfirmFlg = false;
        if (value) {
            this.$router.push({ path: '/login' }, () => {});
        }
    }
    private onClickLogOut() {
        this.logoutConfirmFlg = true;
    }
}
